import { graphql } from "../gql";

export const createUbClaimFindingsMutationDoc = graphql(`
  mutation createUbClaimFindings($input: CreateUbClaimFindingsInput!) {
    createUbClaimFindings(input: $input) {
      auditFindings {
        accepted
        auditFindingRuleType
        auditFindingRuleTypeByAuditFindingRuleType {
          description
          displayName
          type
        }
        auditFindingSeedType
        auditType
        auditorComment
        auditorReviewed
        author {
          email
          firstName
          id
          lastName
        }
        batchClaimId
        batchClaimLineId
        batchClaimLineItemAudit {
          id
          batchClaimLineItem {
            alaRowId
            authorId
            batchClaimLineId
            batchClaimLineItemNnIbLines {
              nodes {
                id
                nnIbLine {
                  fingerprint
                  id
                }
                nnIbLineId
              }
            }
            computedValues: batchClaimLineItemComputedValueById {
              determinedAdjustedAllowedAmount
              determinedAdjustedBilledAmount
              determinedDiscrepantAmount
              id
            }
            createdAt
            dateOfServiceEnd
            dateOfServiceStart
            description
            ibLineId
            id
            itemNumber
            lineNumber
            procedureCode
            revCode
            unitCharge
            units
            updatedAt
          }
        }
        confidence
        createdAt
        discrepantAmount
        id
        improperPaymentCost
        improperPaymentReason
        improperPaymentUnitsCharged
        isActive
        isOriginal
        metaDataAocPrimaryCode
        metaDataEmCode
        metaDataEmCorrectLevel
        metaDataEmOriginalLevel
        metaDataNcciMueAjudicationValue
        metaDataNcciMueOhpMueValue
        metaDataNcciPtpCode
        metaDataNcciPtpModifier
        metaDataPricingCorrectPrice
        metaDataUnitsCorrectUnits
        needsReview
        original: auditFindingReviewByReviewId {
          auditFinding: original {
            accepted
            auditFindingRuleType
            auditFindingRuleTypeByAuditFindingRuleType {
              description
              displayName
              type
            }
            auditFindingSeedType
            auditType
            auditorComment
            auditorReviewed
            author {
              email
              firstName
              id
              lastName
            }
            batchClaimId
            batchClaimLineId
            batchClaimLineItemAudit {
              id
              batchClaimLineItem {
                alaRowId
                authorId
                batchClaimLineId
                batchClaimLineItemNnIbLines {
                  nodes {
                    id
                    nnIbLine {
                      fingerprint
                      id
                    }
                    nnIbLineId
                  }
                }
                computedValues: batchClaimLineItemComputedValueById {
                  determinedAdjustedAllowedAmount
                  determinedAdjustedBilledAmount
                  determinedDiscrepantAmount
                  id
                }
                createdAt
                dateOfServiceEnd
                dateOfServiceStart
                description
                ibLineId
                id
                itemNumber
                lineNumber
                procedureCode
                revCode
                unitCharge
                units
                updatedAt
              }
            }
            confidence
            createdAt
            discrepantAmount
            id
            improperPaymentCost
            improperPaymentReason
            improperPaymentUnitsCharged
            isActive
            isOriginal
            metaDataAocPrimaryCode
            metaDataEmCode
            metaDataEmCorrectLevel
            metaDataEmOriginalLevel
            metaDataNcciMueAjudicationValue
            metaDataNcciMueOhpMueValue
            metaDataNcciPtpCode
            metaDataNcciPtpModifier
            metaDataPricingCorrectPrice
            metaDataUnitsCorrectUnits
            needsReview
            reportedFindings {
              nodes {
                auditFindingReportId
                id
              }
              totalCount
            }
            reviewedAuditFinding: latestReview {
              accepted
              createdAt
              deleted
              id
              rationale
              updatedAt
            }
            reviews: auditFindingReviewsByOriginalId(orderBy: CREATED_AT_DESC) {
              nodes {
                auditFinding: review {
                  accepted
                  auditFindingRuleType
                  auditFindingRuleTypeByAuditFindingRuleType {
                    description
                    displayName
                    type
                  }
                  auditFindingSeedType
                  auditType
                  auditorComment
                  auditorReviewed
                  author {
                    email
                    firstName
                    id
                    lastName
                  }
                  batchClaimId
                  batchClaimLineId
                  batchClaimLineItemAudit {
                    id
                    batchClaimLineItem {
                      alaRowId
                      authorId
                      batchClaimLineId
                      batchClaimLineItemNnIbLines {
                        nodes {
                          id
                          nnIbLine {
                            fingerprint
                            id
                          }
                          nnIbLineId
                        }
                      }
                      computedValues: batchClaimLineItemComputedValueById {
                        determinedAdjustedAllowedAmount
                        determinedAdjustedBilledAmount
                        determinedDiscrepantAmount
                        id
                      }
                      createdAt
                      dateOfServiceEnd
                      dateOfServiceStart
                      description
                      ibLineId
                      id
                      itemNumber
                      lineNumber
                      procedureCode
                      revCode
                      unitCharge
                      units
                      updatedAt
                    }
                  }
                  confidence
                  createdAt
                  discrepantAmount
                  id
                  improperPaymentCost
                  improperPaymentReason
                  improperPaymentUnitsCharged
                  isActive
                  isOriginal
                  metaDataAocPrimaryCode
                  metaDataEmCode
                  metaDataEmCorrectLevel
                  metaDataEmOriginalLevel
                  metaDataNcciMueAjudicationValue
                  metaDataNcciMueOhpMueValue
                  metaDataNcciPtpCode
                  metaDataNcciPtpModifier
                  metaDataPricingCorrectPrice
                  metaDataUnitsCorrectUnits
                  needsReview
                  reportedFindings {
                    nodes {
                      auditFindingReportId
                      id
                    }
                    totalCount
                  }
                  reviewedAuditFinding: latestReview {
                    accepted
                    createdAt
                    deleted
                    id
                    rationale
                    updatedAt
                  }
                  superseded
                }
                createdAt
                id
                originalId
                reviewId
              }
              totalCount
            }
            superseded
          }
          createdAt
          id
          originalId
          reviewId
        }
        reportedFindings {
          nodes {
            auditFindingReportId
            id
          }
          totalCount
        }
        reviewedAuditFinding: latestReview {
          accepted
          createdAt
          deleted
          id
          rationale
          updatedAt
        }
        reviews: auditFindingReviewsByOriginalId(orderBy: CREATED_AT_DESC) {
          nodes {
            auditFinding: review {
              accepted
              auditFindingRuleType
              auditFindingRuleTypeByAuditFindingRuleType {
                description
                displayName
                type
              }
              auditFindingSeedType
              auditType
              auditorComment
              auditorReviewed
              author {
                email
                firstName
                id
                lastName
              }
              batchClaimId
              batchClaimLineId
              batchClaimLineItemAudit {
                id
                batchClaimLineItem {
                  alaRowId
                  authorId
                  batchClaimLineId
                  batchClaimLineItemNnIbLines {
                    nodes {
                      id
                      nnIbLine {
                        fingerprint
                        id
                      }
                      nnIbLineId
                    }
                  }
                  computedValues: batchClaimLineItemComputedValueById {
                    determinedAdjustedAllowedAmount
                    determinedAdjustedBilledAmount
                    determinedDiscrepantAmount
                    id
                  }
                  createdAt
                  dateOfServiceEnd
                  dateOfServiceStart
                  description
                  ibLineId
                  id
                  itemNumber
                  lineNumber
                  procedureCode
                  revCode
                  unitCharge
                  units
                  updatedAt
                }
              }
              confidence
              createdAt
              discrepantAmount
              id
              improperPaymentCost
              improperPaymentReason
              improperPaymentUnitsCharged
              isActive
              isOriginal
              metaDataAocPrimaryCode
              metaDataEmCode
              metaDataEmCorrectLevel
              metaDataEmOriginalLevel
              metaDataNcciMueAjudicationValue
              metaDataNcciMueOhpMueValue
              metaDataNcciPtpCode
              metaDataNcciPtpModifier
              metaDataPricingCorrectPrice
              metaDataUnitsCorrectUnits
              needsReview
              reportedFindings {
                nodes {
                  auditFindingReportId
                  id
                }
                totalCount
              }
              reviewedAuditFinding: latestReview {
                accepted
                createdAt
                deleted
                id
                rationale
                updatedAt
              }
              superseded
            }
            createdAt
            id
            originalId
            reviewId
          }
          totalCount
        }
        superseded
      }
    }
  }
`);
